export { transformerFingerprint } from './transformer';
export type { FingerprintSettings } from './types';

export { transformerFingerprint as default } from './transformer';
